// extracted by mini-css-extract-plugin
export var csatScore = "_gy-5";
export var header = "_gy-1";
export var panelWrapper = "_gy-2";
export var postPreview = "_gy-3";
export var rightContent = "_gy-0";
export var wrappingText = "_gy-4";